module.exports = __webpack_public_path__ + "img/explosion-4.bbb0f62a.png";